var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-sso btn-sso-facebook font-button",on:{"click":_vm.signIn}},[_c('a-facebook-icon'),_vm._v(" "+_vm._s(_vm.message)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }